const ImageIcon = () => {
  return (
    <svg
      width="60"
      height="61"
      viewBox="0 0 60 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M60 53.9681V7.30143C60 3.63477 57 0.634766 53.3333 0.634766H6.66667C3 0.634766 0 3.63477 0 7.30143V53.9681C0 57.6348 3 60.6348 6.66667 60.6348H53.3333C57 60.6348 60 57.6348 60 53.9681ZM19.6667 37.2348L26.6667 45.6681L37 32.3681C37.6667 31.5014 39 31.5014 39.6667 32.4014L51.3667 48.0014C52.2 49.1014 51.4 50.6681 50.0333 50.6681H10.0667C8.66667 50.6681 7.9 49.0681 8.76667 47.9681L17.0667 37.3014C17.7 36.4348 18.9667 36.4014 19.6667 37.2348Z"
        fill="#EBEBEB"
      />
    </svg>
  );
};

export default ImageIcon;
